import { guidanceFor } from '../../../shared/finding-guidance.mjs';

export default function FindingGuidance({ id }) {
  const g = guidanceFor(id);
  if (!g) return null;
  const linkClass = 'inline-flex items-center rounded-md border px-3 py-1.5 text-xs font-medium';
  return (
    <div className="space-y-3" data-testid="finding-guidance">
      <div>
        <div className="mb-1 text-xs font-semibold uppercase tracking-wide text-ipc-muted">Impact</div>
        <p className="text-sm text-ipc-ink">{g.impact}</p>
      </div>
      <div>
        <div className="mb-1 text-xs font-semibold uppercase tracking-wide text-ipc-muted">How to fix</div>
        <ol className="list-decimal pl-5 space-y-1 text-sm text-ipc-ink">
          {g.steps.map((step) => <li key={step}>{step}</li>)}
        </ol>
      </div>
      <div className="flex flex-wrap gap-2">
        <a href={g.adminCenter.url} target="_blank" rel="noopener noreferrer" title={g.adminCenter.label}
          className={`${linkClass} border-blue-600 bg-blue-600 text-white hover:bg-blue-700`}>
          Open in Entra admin center
        </a>
        <a href={g.learn.url} target="_blank" rel="noopener noreferrer" title={g.learn.label}
          className={`${linkClass} border-slate-300 bg-white text-slate-700 hover:bg-slate-50`}>
          Microsoft Learn
        </a>
      </div>
    </div>
  );
}
